import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LstAuthGuard } from '@savvaslearning/lst-auth';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./components/standalone/standalone.module')
            .then((m) => m.StandaloneModule),
        canActivate: [LstAuthGuard],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
